<template>
  <section v-if="registered" class="reg-finished">
    <img class="reg-fin-img" src="~@/assets/registerPage/mail-verif-ic.svg" />
    <AdaptiveSpace staticHeight="5vh" />
    <h3 class="reg-finished-title">{{ $t('signup.mail_header') }}</h3>
    <AdaptiveSpace staticHeight="5vh" />
    <p class="reg-fin-text-top">{{ $t('signup.verify_email') }}</p>
    <p class="reg-fin-email">{{ registeredEmail }}</p>
    <p class="reg-fin-text-bottom">
      {{ $t('signup.mail_confirm') }}
    </p>
    <AdaptiveSpace staticHeight="8vh" />
    <button @click="sendAgain" class="reg-fin-resend">
      {{ $t('signup.send_again') }}
    </button>
    <AdaptiveSpace staticHeight="10vh" />
    <div>
      <p class="complete-subtitle">{{ $t('signup.download_app') }}</p>
      <div class="reg-flex">
        <a
          class="reg-fin-atag complete-download-image"
          href="https://apps.apple.com/us/app/qwello/id1499322729?ls=1"
          ><img src="~@/assets/registerPage/apple-app-store-btn-DE.svg"
        /></a>
        <a
          class="complete-download-image"
          href="https://play.google.com/store/apps/details?id=eu.qwello.app"
          ><img src="~@/assets/registerPage/google-play-store-btn-DE.svg"
        /></a>
      </div>
    </div>
  </section>
</template>

<script>
import AdaptiveSpace from './AdaptiveSpace.vue';

export default {
  name: 'RegistrationSuccess',
  components: { AdaptiveSpace },
  props: ['registered', 'sendAgain', 'registeredEmail'],
};
</script>

<style scoped>
.reg-finished {
  text-align: center;
  --download-image-width: 40vw;
}
.reg-fin-text-top {
  color: #2b4047;
  font-size: 16px;
}
.reg-fin-text-bottom,
.reg-fin-email {
  padding-top: var(--fin-text-padding);
  color: #2b4047;
  font-size: 16px;
}
.reg-fin-text-bottom {
  max-width: 90%;
  margin: 0 auto;
}
.reg-fin-img {
  margin: 0 auto;
  height: var(--mail-icon-height);
}
.reg-fin-email {
  font-weight: bold;
  font-size: 18px;
}
.reg-finished-title {
  color: #2b4047;
  font-size: 30px;
  font-weight: bold;
}
.reg-fin-resend {
  color: #5e7177;
  font-size: 16px;
  border: 2px solid #5e7177;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 30px;
  height: 42px;
  width: 165px;
}

/* TODO(greg) fix the ordering */

.complete-subtitle {
  padding-bottom: 0.8em;
  color: #2b4047;
}
.reg-flex {
  display: flex;
  justify-content: center;
}

.complete-download-image {
  max-width: var(--download-image-width);
}

/* DESKTOP */
@media (min-width: 1024px) {
  .reg-finished {
    --download-image-width: auto;
  }
}
.reg-fin-atag {
  margin-right: 30px;
}
</style>
